import { ApiEndpoint } from '@xylabs/sdk-js'

import { WorldEngineStatsJson } from '../../engine'
import { XyoWorldMinterJsonObject } from '../Minter'
import { XyoWorldApiConfig } from './XyoWorldApiConfig'

export class XyoWorldApiWrapper {
  public engineStats: ApiEndpoint<WorldEngineStatsJson>
  public webData: ApiEndpoint<XyoWorldMinterJsonObject>

  private constructor(config: XyoWorldApiConfig) {
    this.webData = new ApiEndpoint<XyoWorldMinterJsonObject>(config, 'webdata')
    this.engineStats = new ApiEndpoint<WorldEngineStatsJson>(config, 'engine/stats')
  }

  static get(config: XyoWorldApiConfig) {
    return new XyoWorldApiWrapper(config)
  }
}
